// extracted by mini-css-extract-plugin
module.exports = {"header":"MenuHeader_header__3Sk6D","left":"MenuHeader_left__wGxrd","right":"MenuHeader_right__kgvbi","logo":"MenuHeader_logo__cCOi4","shopTitle":"MenuHeader_shopTitle__2htRj"};